export { Dots } from './Component'
